import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InputMask from 'react-input-mask';
import { VscLoading } from 'react-icons/vsc';
import { IoIosArrowDown } from 'react-icons/io';
import * as Validation from 'availity-reactstrap-validation';
import * as Reactstrap from 'reactstrap';

import { emailInfos } from '~/config/help';
import Footer from '~/Components/Footer';
import * as searcActions from '~/store/modules/search/actions';
import * as helpActions from '~/store/modules/help/actions';
import * as Styles from './styles';

const Help = () => {
	const dispatch = useDispatch();
	const { data, done } = useSelector((e) => e.search);
	const { loading, success, error } = useSelector((e) => e.help);

	const [searchText, setSearchText] = useState('');

	const [state, applyState] = useState({
		reportName: '',
		reportEmail: '',
		reportPhone: '',
		reportMessage: '',
		subject: '',
		recipient: '',
	});

	function handleSendEmail() {
		dispatch(
			helpActions.sendEmailResquest({
				...state,
				sender: process.env.REACT_APP_GEOPORTAL_EMAIL,
			})
		);
	}

	function setState(value) {
		if (!value) {
			const newState = {};
			Object.keys(state).forEach((e) => {
				newState[e] = '';
			});

			applyState(newState);
		} else {
			applyState({ ...state, ...value });
		}
	}

	return (
		<>
			<Styles.Content>
				<Styles.Search>
					<h1>Encontre os serviços do GEOPORTAL</h1>

					<Styles.InputSearch
						style={{ maxWidth: '500px' }}
						type="search"
						placeholder="DIGITE O SERVIÇO DESEJADO AQUI"
						value={searchText}
						onChange={({ target: { value } }) => {
							dispatch(searcActions.searchResquest(value));

							setSearchText(value);
						}}
					/>

					<small>
						Busque pelo nome do serviço, como &nbsp;
						<span style={{ textDecoration: 'underline' }}>
							DOCUMENTO 1
						</span>
						&nbsp;ou&nbsp;
						<span style={{ textDecoration: 'underline' }}>
							DOCUMENTO 2
						</span>
					</small>
				</Styles.Search>
				<Styles.Box>
					{done && (
						<Styles.ResultsTitle>
							RESULTADO DE BUSCA PARA &quot;{searchText || ' '}
							&quot;
						</Styles.ResultsTitle>
					)}

					{data[0] && done && (
						<>
							<Reactstrap.Table borderless hover>
								<tbody>
									{data.map((e, i) => (
										<tr key={String(i)}>
											<td>
												<a
													href={e.link}
													target="_blank"
													rel="noopener noreferrer"
												>
													{e.label}
												</a>
											</td>
										</tr>
									))}
								</tbody>
							</Reactstrap.Table>
							<Styles.Hr />
						</>
					)}

					<Validation.AvForm
						onValidSubmit={handleSendEmail}
						style={{ paddingTop: data[0] && done ? '20px' : '0' }}
					>
						<Styles.ContactTitle>
							<p>CONTATO</p>
							<small>
								Entre em contato conosco e tire sua dúvida
							</small>
						</Styles.ContactTitle>
						{!success && !error ? (
							<>
								<Validation.AvGroup>
									<Reactstrap.UncontrolledDropdown>
										<Reactstrap.DropdownToggle
											tag="button"
											type="button"
											className="form-control text-left d-flex align-items-center justify-content-between"
										>
											<span className="mr-1 text-truncate">
												{state.subject ? (
													<>
														<strong>
															Assunto:{' '}
														</strong>
														{state.subject}
													</>
												) : (
													'Escolha um assunto'
												)}
											</span>
											<IoIosArrowDown
												size={12}
												style={{
													minWidth: '12px',
													minHeight: '12px',
												}}
											/>
										</Reactstrap.DropdownToggle>
										<Reactstrap.DropdownMenu className="w-100">
											{emailInfos.map((e) => (
												<Reactstrap.DropdownItem
													className="text-wrap"
													onClick={() => setState(e)}
												>
													{e.subject}
												</Reactstrap.DropdownItem>
											))}
										</Reactstrap.DropdownMenu>
									</Reactstrap.UncontrolledDropdown>
									<Validation.AvInput
										required
										type="hidden"
										name="email_subject"
										id="email_subject"
										value={state.subject}
									/>
									<Validation.AvFeedback>
										Este campo é obrigatório
									</Validation.AvFeedback>
								</Validation.AvGroup>
								<Reactstrap.Row form>
									<Reactstrap.Col md={4}>
										<Validation.AvGroup>
											<Reactstrap.Input
												type="text"
												disabled={loading}
												placeholder="Nome completo"
												value={state.reportName}
												onChange={({
													target: { value },
												}) =>
													setState({
														reportName: value,
													})
												}
											/>
											<Validation.AvInput
												required
												type="hidden"
												name="completeName"
												id="completeNameInput"
												value={state.reportName}
											/>
											<Validation.AvFeedback>
												Este campo é obrigatório
											</Validation.AvFeedback>
										</Validation.AvGroup>
									</Reactstrap.Col>
									<Reactstrap.Col md={4}>
										<Validation.AvGroup>
											<Reactstrap.Input
												type="email"
												disabled={loading}
												placeholder="Email"
												value={state.reportEmail}
												onChange={({
													target: { value },
												}) =>
													setState({
														reportEmail: value,
													})
												}
											/>
											<Validation.AvInput
												required
												type="hidden"
												name="email"
												id="emailInput"
												value={state.reportEmail}
											/>
											<Validation.AvFeedback>
												Este campo é obrigatório
											</Validation.AvFeedback>
										</Validation.AvGroup>
									</Reactstrap.Col>
									<Reactstrap.Col md={4}>
										<Validation.AvGroup>
											<InputMask
												type="text"
												disabled={loading}
												placeholder="Telefone para contato"
												mask="(99) 99999-9999"
												className="form-control"
												value={state.reportPhone}
												onChange={({
													target: { value },
												}) =>
													setState({
														reportPhone: value,
													})
												}
											/>
											<Validation.AvInput
												required
												type="hidden"
												name="phone"
												id="phoneInput"
												value={state.reportPhone}
											/>
											<Validation.AvFeedback>
												Este campo é obrigatório
											</Validation.AvFeedback>
										</Validation.AvGroup>
									</Reactstrap.Col>
								</Reactstrap.Row>
								<Validation.AvGroup>
									<Reactstrap.Input
										disabled={loading}
										type="textarea"
										placeholder="Conte-nos a sua dúvida"
										value={state.reportMessage}
										onChange={({ target: { value } }) =>
											setState({ reportMessage: value })
										}
									/>
									<Validation.AvInput
										required
										type="hidden"
										name="text"
										id="textInput"
										value={state.reportMessage}
									/>
									<Validation.AvFeedback>
										Este campo é obrigatório
									</Validation.AvFeedback>
								</Validation.AvGroup>
							</>
						) : (
							<Styles.FeedbackMessage
								type={success ? 'success' : 'error'}
							>
								{success
									? 'Email enviado com sucesso'
									: 'Houve um erro ao tentar enviar o email'}
							</Styles.FeedbackMessage>
						)}

						<Styles.BtnCont>
							{success ? (
								<Reactstrap.Button
									type="button"
									color="info"
									onClick={() => {
										dispatch(helpActions.clearSuccess());
										setState(null);
									}}
								>
									ENVIAR OUTRO E-MAIL
								</Reactstrap.Button>
							) : (
								<>
									<Styles.ButtonSend
										color="info"
										type="submit"
										disabled={loading}
									>
										{error ? 'TENTAR NOVAMENTE' : 'ENVIAR'}
										<div>
											<VscLoading
												size={25}
												color="#fff"
											/>
										</div>
									</Styles.ButtonSend>

									{error && !loading && (
										<Styles.LinkCancel
											onClick={() => {
												dispatch(
													helpActions.clearError()
												);
												setState(null);
											}}
										>
											Cancelar envio
										</Styles.LinkCancel>
									)}
								</>
							)}
						</Styles.BtnCont>
					</Validation.AvForm>

					<Styles.Hr />
					{/* <Styles.ContactTitle style={{ paddingTop: '20px' }}>
						<p>PERGUNTAS FREQUENTES</p>
					</Styles.ContactTitle>

					<Styles.Accordeon>
						<Styles.AccordeonItem>
							<a
								href="/"
								target="_blank"
								rel="noopener noreferrer"
								id="common-questions-1"
							>
								Como abrir arquivos shapefile?
							</a>

							<div style={{ marginTop: '10px' }} />
							<Reactstrap.UncontrolledCollapse toggler="#common-questions-1">
								<Reactstrap.Card>
									<Reactstrap.CardBody>
										<Styles.Paragraph>
											Esses arquivos são nativos dos
											programas da família ArcView/ArcGIS,
											da empresa norte-americana ESRI.
											Eles armazenam dados geográficos no
											formato vetorial, podendo ser do
											tipo ponto ou linha ou polígono.
										</Styles.Paragraph>
										<Styles.Paragraph>
											O shapefile é formado por um
											conjunto de arquivos de mesmo nome
											mas diferentes extensões. São
											arquivos obrigatórios os de extensão
											*.shp, *.shx e *.dbf. Sem a presença
											dessas três extensões em um mesmo
											diretório, os softwares não
											conseguem fazer a leitura.
										</Styles.Paragraph>
										<Styles.Paragraph>
											É possível visualizar os arquivos
											shapefile utilizando programas de
											SIG, como Quantum GIS e ArcGIS.
										</Styles.Paragraph>
									</Reactstrap.CardBody>
								</Reactstrap.Card>
							</Reactstrap.UncontrolledCollapse>
						</Styles.AccordeonItem>

						<Styles.AccordeonItem>
							<a
								href="/"
								target="_blank"
								rel="noopener noreferrer"
								id="common-questions-4"
							>
								Quais os formatos dos arquivos vetoriais
								disponíveis para download
							</a>
							<div style={{ marginTop: '10px' }} />
							<Reactstrap.UncontrolledCollapse toggler="#common-questions-4">
								<Reactstrap.Card>
									<Reactstrap.CardBody>
										<Styles.Paragraph>
											Os arquivos são disponibilizados em
											formatos shapefile e KML, datum
											SIRGAS2000.
										</Styles.Paragraph>
									</Reactstrap.CardBody>
								</Reactstrap.Card>
							</Reactstrap.UncontrolledCollapse>
						</Styles.AccordeonItem>

						<Styles.AccordeonItem>
							<a
								href="/"
								target="_blank"
								rel="noopener noreferrer"
								id="common-questions-6"
							>
								O que são metadados?
							</a>
							<div style={{ marginTop: '10px' }} />
							<Reactstrap.UncontrolledCollapse toggler="#common-questions-6">
								<Reactstrap.Card>
									<Reactstrap.CardBody>
										<Styles.Paragraph>
											Metadados são informações de
											determinado dado. Os metadados são
											essenciais para organização e
											classificação de conjuntos de dados.
											Contemplam informações como: título,
											nome do arquivo, tipo de arquivo,
											geometria, escala de vetorização,
											Datum, Fuso UTM.
										</Styles.Paragraph>
									</Reactstrap.CardBody>
								</Reactstrap.Card>
							</Reactstrap.UncontrolledCollapse>
						</Styles.AccordeonItem>

						<Styles.AccordeonItem>
							<a
								href="/"
								target="_blank"
								rel="noopener noreferrer"
								id="common-questions-12"
							>
								O que é o levantamento planialtimétrico?
							</a>
							<div style={{ marginTop: '10px' }} />
							<Reactstrap.UncontrolledCollapse toggler="#common-questions-12">
								<Reactstrap.Card>
									<Reactstrap.CardBody>
										<Styles.Paragraph>
											O levantamento planialtimétrico é um
											levantamento topográfico que
											descreve o terreno por completo. O
											objetivo é uma planta topográfica
											que possua declividade e altimetria
											de uma determinada área. O
											Levantamento planialtimétrico deve
											conter memorial descritivo e ser
											acompanhado de sua respectiva
											Anotação de Responsabilidade Técnica
											– ART.
										</Styles.Paragraph>
									</Reactstrap.CardBody>
								</Reactstrap.Card>
							</Reactstrap.UncontrolledCollapse>
						</Styles.AccordeonItem>
					</Styles.Accordeon> */}
					<Styles.Hr />
					<Styles.ContactTitle style={{ paddingTop: '20px' }}>
						<p>ENTRE EM CONTATO</p>
					</Styles.ContactTitle>

					<Styles.ContactContent>
						<Reactstrap.Col
							md={4}
							className="d-flex justify-content-center align-items-start"
						>
							<div className="item">
								<p>TELEFONE</p>
								<a href="tel:03732296500">(37) 3229-6500</a>
							</div>
						</Reactstrap.Col>
						{/* <Reactstrap.Col
							md={3}
							className="d-flex justify-content-center align-items-start"
						>
							<div className="item">
								<p>EMAIL</p>
								<a href="mailto:dicgp.ipuf@pmf.sc.gov.br">
									dicgp.ipuf@pmf.sc.gov.br
								</a>
							</div>
						</Reactstrap.Col> */}
						<Reactstrap.Col
							md={4}
							className="d-flex justify-content-center align-items-start"
						>
							<div className="item">
								<p>ENDEREÇO</p>
								<a
									href="https://www.google.com/maps?client=firefox-b-d&q=Avenida+Paran%C3%A1,+2.601+-+S%C3%A3o+Jos%C3%A9+CEP:+35501-170&um=1&ie=UTF-8&sa=X&ved=2ahUKEwj_2rDOmIj8AhXipZUCHaTFAQUQ_AUoAXoECAEQAw"
									target="_blank"
									rel="noopener noreferrer"
									style={{
										wordBreak: 'break-word',
									}}
								>
									Avenida Paraná, 2.601 - São José CEP:
									35501-170
								</a>
							</div>
						</Reactstrap.Col>
					</Styles.ContactContent>
				</Styles.Box>
			</Styles.Content>
			<Footer />
		</>
	);
};

export default Help;
